import React, { useState, useEffect } from 'react';
import {FormComponent} from '@formbird/types';
import { convertToCustomElement } from '../utils/CustomElementWrapper';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Collapse from '@material-ui/core/Collapse';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import { red } from '@material-ui/core/colors';
import FavoriteIcon from '@material-ui/icons/Favorite';
import ShareIcon from '@material-ui/icons/Share';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import { SearchService } from '@formbird/services';

const dateOptions = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
const dateFormat = new Intl.DateTimeFormat('en-GB', dateOptions);

// function getImagePath(component) {
//   return `api/getFile/${component.componentImage.serverAssignedFileNo}/${component.componentImage.fileName}`;
// }

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      maxWidth: 345,
    },
    media: {
      height: 0,
      paddingTop: '56.25%', // 16:9
    },
    expand: {
      transform: 'rotate(0deg)',
      marginLeft: 'auto',
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
      }),
    },
    expandOpen: {
      transform: 'rotate(180deg)',
    },
    avatar: {
      backgroundColor: red[500],
    },
  }),
);

const ReCardsComponent = ({
  document,
  fieldValue,
  template,
  fieldName,
  formParameters,
  key,
  responsiveLayouts,
  message,
  componentDefinition
}) => {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  const [data, setData] = useState([]);

  // const data = [];

  useEffect(() => {
    // if (fieldValue) {
    //   setValue(fieldValue);
    // } else if (componentDefinition.defaultValue) {
    //   setValue(componentDefinition.defaultValue);
    // }

    const anyWindow: any = window;
    const searchService: SearchService = (anyWindow.FormbirdServiceInjector).get('SearchService');
    const options = {
      filter: componentDefinition.filter,
      includeDeleted: true,
      searchOfflineOnly: false,
    };

    searchService.search(options).then((results) => {
      console.log('results = ', results);
      const data = [];
      if (results.data && results.data.hits && results.data.hits.hits) {
        results.data.hits.hits.forEach((item) => {
          const source = item._source;
          // if (ids.indexOf(source.documentId) < 0) {
          //   source.id = source.documentId;
          data.push(source);
          // }
        });

        setData(data);
      }
    });
  }, []);

  return (
    <div>
      {/* if (data) { */}
          {data.map(function(component, i){
        return <Card className={classes.root}>
    <CardHeader
      avatar={
        <Avatar aria-label="component" className={classes.avatar}>
          Component
        </Avatar>
      }
      action={
        <IconButton aria-label="settings">
          <MoreVertIcon />
        </IconButton>
      }
      title={component.systemHeader.summaryName}
      subheader={dateFormat.format(new Date(component.systemHeader.createdDate))}
    />
    <CardMedia
      className={classes.media}
      image={component.componentImage && component.comopnentImage[0] && component.componentImage[0].serverAssignedFileNo ? 
             'api/getFile/' + component.componentImage[0].serverAssignedFileNo + '/' + component.componentImage[0].fileName :
             ""}
      title="{component.name}"
    />
    <CardContent>
      <Typography variant="body2" color="textSecondary" component="p">
        {component.versionInfo}
      </Typography>
    </CardContent>
    <CardActions disableSpacing>
      <IconButton aria-label="add to favorites">
        <FavoriteIcon />
      </IconButton>
      <IconButton aria-label="share">
        <ShareIcon />
      </IconButton>
      <IconButton
        className={clsx(classes.expand, {
          [classes.expandOpen]: expanded,
        })}
        onClick={handleExpandClick}
        aria-expanded={expanded}
        aria-label="show more"
      >
        <ExpandMoreIcon />
      </IconButton>
    </CardActions>
    <Collapse in={expanded} timeout="auto" unmountOnExit>
      <CardContent>
        <Typography paragraph>Method:</Typography>
        <Typography paragraph>
          Heat 1/2 cup of the broth in a pot until simmering, add saffron and set aside for 10
          minutes.
        </Typography>
        <Typography paragraph>
          Heat oil in a (14- to 16-inch) paella pan or a large, deep skillet over medium-high
          heat. Add chicken, shrimp and chorizo, and cook, stirring occasionally until lightly
          browned, 6 to 8 minutes. Transfer shrimp to a large plate and set aside, leaving chicken
          and chorizo in the pan. Add pimentón, bay leaves, garlic, tomatoes, onion, salt and
          pepper, and cook, stirring often until thickened and fragrant, about 10 minutes. Add
          saffron broth and remaining 4 1/2 cups chicken broth; bring to a boil.
        </Typography>
        <Typography paragraph>
          Add rice and stir very gently to distribute. Top with artichokes and peppers, and cook
          without stirring, until most of the liquid is absorbed, 15 to 18 minutes. Reduce heat to
          medium-low, add reserved shrimp and mussels, tucking them down into the rice, and cook
          again without stirring, until mussels have opened and rice is just tender, 5 to 7
          minutes more. (Discard any mussels that don’t open.)
        </Typography>
        <Typography>
          Set aside off of the heat to let rest for 10 minutes, and then serve.
        </Typography>
      </CardContent>
    </Collapse>
  </Card>
      })}
  </div>
  );
};

// register the component as a custom element so it can be shown in formbird
convertToCustomElement('re-cards', ReCardsComponent);

export default ReCardsComponent;
